<div class="assessment-overlay" (click)="closeModal()">

  <div class="assessment-modal" (click)="$event.stopPropagation()">

    <!-- HEADER -->
    <div class="assessment-header">

      <div class="assessment-header__left">

        <div class="assessment-header__icon">
          <i class="bi bi-clipboard-check"></i>
        </div>

        <div>
          <h2>Create Assessment</h2>

          <p>
            Create an assessment from this document
          </p>
        </div>

      </div>

      <button type="button" class="assessment-close" (click)="closeModal()">
        <i class="bi bi-x-lg"></i>
      </button>

    </div>


    <!-- BODY -->
    <div class="assessment-body">

      <!-- DOCUMENT INFO -->
      <div class="document-info">

        <div class="document-info__icon">
          <i class="bi bi-file-earmark-text"></i>
        </div>

        <div class="document-info__content">

          <span class="document-info__label">
            Source document
          </span>

          <strong>
            {{ document?.file_name || document?.message || 'Document' }}
          </strong>

        </div>

      </div>


      <!-- BASIC INFORMATION -->
      <section class="assessment-section">

        <div class="section-heading">

          <div>
            <h3>Assessment details</h3>

            <p>
              Provide basic information about this assessment.
            </p>
          </div>

        </div>


        <div class="form-grid">

          <div class="form-group form-group--full">

            <label>
              Assessment title
              <span>*</span>
            </label>

            <input type="text" class="form-control" [(ngModel)]="assessmentTitle"
              placeholder="e.g. Employee Policy Assessment" />

          </div>


          <div class="form-group form-group--full">

            <label>Description</label>

            <textarea class="form-control form-control--textarea" [(ngModel)]="description" rows="3"
              placeholder="Describe what this assessment covers..."></textarea>

          </div>


          <div class="form-group">

            <label>Duration</label>

            <div class="input-with-suffix">

              <input type="number" class="form-control" [(ngModel)]="duration" min="1" />

              <span>minutes</span>

            </div>

          </div>


          <div class="form-group">

            <label>Passing score</label>

            <div class="input-with-suffix">

              <input type="number" class="form-control" [(ngModel)]="passingScore" min="0" max="100" />

              <span>%</span>

            </div>

          </div>

        </div>

      </section>


      <!-- QUESTIONS -->
      <section class="assessment-section">

        <div class="section-heading section-heading--questions">

          <div>

            <h3>Questions</h3>

            <p>
              Add questions that learners will answer.
            </p>

          </div>

          <button type="button" class="btn btn-primary" (click)="openQuestionForm()">
            <i class="bi bi-plus-lg"></i>
            Add question
          </button>

        </div>


        <!-- EMPTY STATE -->
        <div class="question-empty" *ngIf="questions.length === 0">

          <div class="question-empty__icon">
            <i class="bi bi-question-circle"></i>
          </div>

          <h4>No questions added yet</h4>

          <p>
            Add your first question to build the assessment.
          </p>

          <button type="button" class="btn btn-secondary" (click)="openQuestionForm()">
            <i class="bi bi-plus-lg"></i>
            Add first question
          </button>

        </div>


        <!-- QUESTION LIST -->
        <div class="question-list" *ngIf="questions.length">

          <div class="question-card" *ngFor="let item of questions; let i = index">

            <div class="question-card__number">
              {{ i + 1 }}
            </div>


            <div class="question-card__content">

              <div class="question-card__top">

                <span class="question-type">
                  {{ item.type === 'single'
                  ? 'Single choice'
                  : item.type === 'multiple'
                  ? 'Multiple choice'
                  : 'True / False'
                  }}
                </span>

                <span class="question-points">
                  {{ item.points }} point
                </span>

              </div>


              <h4>
                {{ item.question }}
              </h4>


              <div class="question-options">

                <span *ngFor="let option of item.options" class="question-option">
                  {{ option }}
                </span>

              </div>

            </div>


            <div class="question-card__actions">

              <button type="button" title="Edit" (click)="editQuestion(i)">
                <i class="bi bi-pencil"></i>
              </button>

              <button type="button" title="Delete" (click)="removeQuestion(i)">
                <i class="bi bi-trash3"></i>
              </button>

            </div>

          </div>

        </div>

      </section>

    </div>


    <!-- QUESTION FORM -->
    <div class="question-editor-overlay" *ngIf="showQuestionForm">

      <div class="question-editor">

        <div class="question-editor__header">

          <div>

            <h3>
              {{ editingQuestionIndex !== null
              ? 'Edit question'
              : 'Add question'
              }}
            </h3>

            <p>
              Configure the question and answer options.
            </p>

          </div>

          <button type="button" (click)="showQuestionForm = false">
            <i class="bi bi-x-lg"></i>
          </button>

        </div>


        <div class="question-editor__body">

          <div class="form-group">

            <label>
              Question
              <span>*</span>
            </label>

            <textarea class="form-control form-control--textarea" [(ngModel)]="question.question" rows="4"
              placeholder="Enter your question..."></textarea>

          </div>


          <div class="form-grid">

            <div class="form-group">

              <label>Question type</label>

              <select class="form-control" [(ngModel)]="question.type">

                <option value="single">
                  Single choice
                </option>

                <option value="multiple">
                  Multiple choice
                </option>

                <option value="true_false">
                  True / False
                </option>

              </select>

            </div>


            <div class="form-group">

              <label>Points</label>

              <input type="number" class="form-control" [(ngModel)]="question.points" min="1" />

            </div>

          </div>


          <!-- OPTIONS -->
          <div class="options-editor" *ngIf="question.type !== 'true_false'">

            <div class="options-editor__heading">

              <label>Answer options</label>

              <button type="button" (click)="addOption()">
                <i class="bi bi-plus"></i>
                Add option
              </button>

            </div>


            <div class="option-row" *ngFor="
                let option of question.options;
                let optionIndex = index
              ">

              <input type="radio" *ngIf="question.type === 'single'" name="correctAnswer" [value]="option"
                [(ngModel)]="question.correctAnswer" />


              <input type="checkbox" *ngIf="question.type === 'multiple'" />


              <input type="text" class="form-control" [(ngModel)]="question.options[optionIndex]"
                [placeholder]="'Option ' + (optionIndex + 1)" />


              <button type="button" (click)="removeOption(optionIndex)" [disabled]="question.options.length <= 2">
                <i class="bi bi-trash3"></i>
              </button>

            </div>

          </div>


          <!-- TRUE FALSE -->
          <div class="true-false-options" *ngIf="question.type === 'true_false'">

            <label>Correct answer</label>

            <div class="true-false-buttons">

              <button type="button" [class.active]="question.correctAnswer === 'true'"
                (click)="question.correctAnswer = 'true'">
                <i class="bi bi-check-circle"></i>
                True
              </button>

              <button type="button" [class.active]="question.correctAnswer === 'false'"
                (click)="question.correctAnswer = 'false'">
                <i class="bi bi-x-circle"></i>
                False
              </button>

            </div>

          </div>

        </div>


        <div class="question-editor__footer">

          <button type="button" class="btn btn-light" (click)="showQuestionForm = false">
            Cancel
          </button>

          <button type="button" class="btn btn-primary" [disabled]="!question.question.trim()" (click)="saveQuestion()">
            <i class="bi bi-check-lg"></i>

            {{ editingQuestionIndex !== null
            ? 'Update question'
            : 'Add question'
            }}

          </button>

        </div>

      </div>

    </div>


    <!-- FOOTER -->
    <div class="assessment-footer">

      <div class="assessment-summary">

        <span>
          <i class="bi bi-question-circle"></i>
          {{ questions.length }} Questions
        </span>

        <span>
          <i class="bi bi-clock"></i>
          {{ duration }} Minutes
        </span>

      </div>


      <div class="assessment-footer__actions">

        <button type="button" class="btn btn-light" (click)="closeModal()">
          Cancel
        </button>

        <button type="button" class="btn btn-primary" [disabled]="!assessmentTitle.trim() || !questions.length"
          (click)="saveAssessment()">
          <i class="bi bi-check2-circle"></i>
          Save assessment
        </button>

      </div>

    </div>

  </div>

</div>
